import { render, staticRenderFns } from "./RankingQuestion.vue?vue&type=template&id=34a89fb5&scoped=true"
import script from "./RankingQuestion.vue?vue&type=script&lang=js"
export * from "./RankingQuestion.vue?vue&type=script&lang=js"
import style0 from "./RankingQuestion.vue?vue&type=style&index=0&id=34a89fb5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a89fb5",
  null
  
)

export default component.exports